export enum PopupType {
    FIRST_CONNECTION="FIRST_CONNECTION",
    LOGIN="LOGIN",
    LOGIN_With_FIRST_CONNECTION="LOGIN_With_FIRST_CONNECTION"
}